<script lang="ts">
  import ObjectToList from './object-to-list.svelte';

  export let key: string | number = '';
  export let value: any = null;
  // export let parentKey: string | number = '';
  export let parentValue: any = null;
  export let index = 0;
  export let nestIndex = 0;

  export let isColored = false;

  const quote = '\"';
  const separator = ',';
</script>

<li>
  {#if value && typeof value === 'object'}
    {#if key}<code style="padding-inline-start: {nestIndex * 1}em">{key}:</code>{/if}
      {#if Array.isArray(value)}
      <code style="{key ? null : 'padding-inline-start: ' + nestIndex * 1 + 'em'}">{'['}</code>
        <ul>
          {#each value as entry, i}
            <ObjectToList
              key={''}
              value={entry}
              parentValue={value}
              index={i}
              nestIndex={nestIndex += 1}
              {isColored}
            />
          {/each}
        </ul>
        <code style="padding-inline-start: {nestIndex * 1}em">
          {']'}{#if parentValue && typeof parentValue === 'object' && (Array.isArray(parentValue) ? parentValue : Object.keys(parentValue)).length - 1 > index}{separator}{/if}
        </code>
      {:else}
        <code style="{key ? null : 'padding-inline-start: ' + nestIndex * 1 + 'em'}">{'{'}</code>
        <ul>
          {#each Object.entries(value) as [childKey, childValue], i}
            <ObjectToList
              key={childKey}
              value={childValue} 
              parentValue={value}
              index={i}
              nestIndex={nestIndex += 1}
              {isColored}
            />
          {/each}
        </ul>
        <code style="padding-inline-start: {nestIndex * 1}em">
          {'}'}{#if parentValue && typeof parentValue === 'object' && (Array.isArray(parentValue) ? parentValue : Object.keys(parentValue)).length - 1 > index}{separator}{/if}
        </code>
      {/if}
  {:else}
    <code style="padding-inline-start: {nestIndex * 1}em">
      <span>{#if key !== ''}{key}:{/if}</span>
      {#if typeof value === 'string'}{quote}{/if}<span style="{isColored ? 'color: var(--' + typeof value + ')' : null}">{'' + value}</span>{#if typeof value === 'string'}{quote}{/if}{#if parentValue && typeof parentValue === 'object' && (Array.isArray(parentValue) ? parentValue : Object.keys(parentValue)).length - 1 > index}{separator}{/if}
    </code>
  {/if}
</li>

<style>
  ul, li {
    list-style-type: none;
  }
</style>
